<template>
  <div class="beautyList">
    <div class="contain">
      <ul class="left">
        <li v-for="(item, index) in leftList" :key="index">
		  <image class="pic" lazy-load :src="item.imageUrl" mode="aspectFill"  />
		  <div class="cover">
			{{ "已有100人出游" }}
		  </div>            
          <div class="txt">
            <p class="title">
              {{ item.name }}
            </p>
            <div class="labels" v-if="item.districtName">
              <!-- <span v-for="(item, index) in item.label" :key="index">
                {{ item }}
              </span> -->
            <span>{{ item.districtName }}</span>
			</div>
            <p class="foot">
              <span class="lf">
                <span class="symbol">
                  ￥
                </span>
                <span class="money" v-html="item.referPrice"></span>
                <span class="up">起</span>
              </span>
              <span class="sell">
                销量500
              </span>
            </p>
          </div>
        </li>
      </ul>
      <ul class="rt">
        <li v-for="(item, index) in rightList" :key="index">
          <image class="pic" lazy-load :src="item.imageUrl" mode="aspectFill"  >
          </image>
          <div class="cover">
          			{{ "已有100人出游" }}
          </div>
          <div class="txt">
            <p class="title">
              {{ item.name }}
            </p>
            <div class="labels" v-if="item.districtName">
              <!-- <span v-for="(item, index) in item.label" :key="index">
                {{ item }}
              </span> -->
			  <span>{{ item.districtName }}</span>
            </div>
            <p class="foot">
              <span class="lf">
                <span class="symbol">
                  ￥
                </span>
                <span class="money" v-html="item.referPrice"></span>
                <span class="up">起</span>
              </span>
              <span class="sell">
                销量500
              </span>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="more">
      查看更多
    </div>
  </div>
</template>

<script>
import { covertMoney } from "@/common/js/util.js";
export default {
  name: "vanBeauty",
  data() {
    return {
      
    };
  },
  props: {
	  dataList: {
		type: Array,
		default () {
		  return []
		}
	  }
	},
  mounted() {
  },
  computed: {
    leftList() {
      return this.dataList.filter((res, index) => {
		  res.referPrice = covertMoney(res.referPrice)
        return index % 2 === 0;
      });
    },
    rightList() {
      return this.dataList.filter((res, index) => {
		  res.referPrice = covertMoney(res.referPrice)
        return index % 2 === 1;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.more {
  border: #ff740b 1px solid;
  color: #ff740b;
  border-radius: 2px;
  width: 70px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  font-size: 12px;
  margin: 0 auto 10px auto;
  clear: both;
}
.beautyList {
  // margin:5px 15px 5px 15px;
  // overflow: hidden;
  background: #fff;
  overflow: hidden;
  .contain {
    padding-bottom: 10px;
    overflow: hidden;
  }
  .left {
    float: left;
    margin-left: 15px;
  }
  .rt {
    float: left;
    margin-left: 8px;
  }

  .left li,
  .rt li {
    width: 167px;
    overflow: hidden;
    border-radius: 4px;
    background: #fff;
    margin: 5px 0 10px 0;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.12);
    position: relative;
    .pic {
      width: 100%;
      height: 135px;  
    }
	.cover {
	  width: 167px;
	  height: 24px;
	  background: linear-gradient(
	    180deg,
	    rgba(0, 0, 0, 0) 0%,
	    rgba(0, 0, 0, 0.5) 100%
	  );
	  position: absolute;
	  left: 0;
	  top: 111px;
	  font-size: 11px;
	  text-indent: 8px;
	  color: #fff;
	  line-height: 24px;
	}
    .txt {
      padding: 8px 8px 0 8px;
      overflow: hidden;
      .title {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        color: #333;
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        line-height: 21px;
      }
      .labels {
        overflow: hidden;
		margin-top:2px;
        span {
          border: #ff740b 1px solid;
          color: #ff740b;
          padding: 1px 4px;
          border-radius: 2px;
          font-size: 11px;
          font-weight: 400;
          float: left;
          margin-right: 4px;
          line-height: 12px;
        }
      }
      .foot {
        display: flex;
        line-height: 32px;
        justify-content: space-between;
        // margin-top:4px;
        .lf {
          display: flex;
        }
        .symbol {
          font-size: 11px;
          color: #ff5041;
          font-family: PingFangSC-Semibold, PingFang SC;
          // margin:3px 0 0 0;
          // font-weight:600;
        }
        .money {
          font-size: 20px;
          font-weight: bold;
          color: #ff3e2d;
          font-family: HelveticaNeue-Bold, HelveticaNeue;
          margin: -2px 3px 0 0;
          /deep/.number {
            font-size: 11px !important;
          }
        }
        .up {
          font-size: 11px;
          color: #999;
          margin-top: 3px;
        }
        .sell {
          color: #999;
          font-size: 11px;
		  margin-top:3px;
        }
      }
    }
  }
}
</style>
